import Axios from '@/utilities/axios-instance'

const { VUE_APP_CPOST_API_BASEURL: cpApiBaseUrl, VUE_APP_CPOST_KEY: cpKey, VUE_APP_CPOST_TIMEOUT: timeout } = process.env

export default class CandaPostAddressSearch {
  /**
   * Axios wrapper to trigger Canada Post Find Address API
   * @param {string} searchString - the address search string
    * @param {object} params - additional params to pass to the API Ex: "LastId" for subaddress search, "MaxResults" for limiting results
   * @returns {promise}
  */

  static cpFind (searchString, params) {
    const fetchParams = {
      SearchTerm: searchString,
      Country: 'CAN',
      LanguagePreference: 'EN',
      ...params
    }

    const cpFetchEndpoint = `${cpApiBaseUrl}Find/v2.10/json3ex.ws`
    const response = Axios.get(cpFetchEndpoint, {
      params: {
        Key: cpKey,
        ...fetchParams
      },
      timeout

    }).catch(err => {
      throw new Error(err.message)
    })

    return response
  }

  /**
   * Axios wrapper to trigger Canada Post Retrieve Address API. This fetches a single address full data object
   * @param {string} addressId - the addressId returned from the Find Address API
   * @returns {promise}
  */

  static cpRetrieve (addressId) {
    const fetchParams = {
      Id: addressId,
      LanguagePreference: 'EN',
      Country: 'CAN'
    }

    const cpFetchEndpoint = `${cpApiBaseUrl}Retrieve/v2.10/json3ex.ws`
    const response = Axios.get(cpFetchEndpoint, {
      params: {
        Key: cpKey,
        ...fetchParams
      },
      timeout
    }).catch(err => { throw err.response })

    return response
  }
}
